export const notifyPuppeteer = (elementID: string): void => {
  const a = document.createElement('a');
  a.setAttribute('id', elementID);
  document.body.appendChild(a);
};
